import { render, staticRenderFns } from "./customer-statement-report.vue?vue&type=template&id=1397e03e&"
import script from "./customer-statement-report.vue?vue&type=script&lang=ts&"
export * from "./customer-statement-report.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports